import React, { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";
import { scrollToPageTop } from "@/lib/scroll";

/**
 * Floating "back to top" pill anchored to the bottom-right of the viewport.
 * Fades in only after the user has scrolled past ~600 px so it never covers
 * above-the-fold content.
 */
export default function BackToTopButton({ threshold = 600, testId = "back-to-top" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return (
    <button
      type="button"
      onClick={scrollToPageTop}
      aria-label="Back to top"
      data-testid={testId}
      className="fixed bottom-6 right-6 z-40 grid place-items-center w-12 h-12 rounded-full bg-[color:var(--coral)] text-white shadow-lg hover:scale-105 transition-all"
      style={{
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        transform: visible ? "translateY(0)" : "translateY(12px)",
        transitionDuration: "260ms",
      }}
    >
      <ChevronUp className="w-6 h-6" />
    </button>
  );
}
